export default "For info on credit vouchers see our [COVID-19 Help Hub](https://www.jetstar.com/au/en/help/articles/covid-19).\n";